<div nz-row>
    <div
        nz-col
        nzSpan="8"
        nzOffset="8"
        [ngClass]="'login p-3'"
    >

        <h1 nz-typography>Login</h1>

        <p class="small-text">
            "Draga antreprenorule,
            Iti cer o adresa de e-mail ca să ai contul tău securizat în care sa-ți vezi rapoartele de analiza financiara actuale sau istorice și sa poți face comparații între perioadele de evolutie ale afacerii tale.
        </p>

        <p
            class="small-text"
            style="font-weight: 700; font-size: 16px"
        >
            Sa fie cash și sa ai multa energie!
        </p>

        <div class="auth-btn-wrapper">
            <!-- [routerLink]="['/','login',{display: 'verbose'},'returnUrl']" -->
            <a
                class="ant-btn ant-btn-primary login-form-button"
                (click)="goTop()"
                rel="nofollow"
            >
                <span style="text-transform: uppercase">Autentificare</span>
                / Am deja un cont
            </a>

            <a
                class="ant-btn ant-btn-primary login-form-button"
                routerLink="/register"
            >
                <span style="text-transform: uppercase">Inregistrare</span>
                / Sunt client nou
            </a>
        </div>

    </div>
</div>
